import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SwiperModule } from 'swiper/angular';
import { NgOtpInputModule } from  'ng-otp-input';
import { CurrencyModule } from '@app/directives';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';


import { FilePondModule, registerPlugin } from '@app/components/file-pond';

// import and register filepond file type validation plugin
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import * as FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import * as FilePondPluginValidateSize from 'filepond-plugin-file-validate-size';
// import * as FilePondPluginImageEdit from 'filepond-plugin-image-edit';
registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginImagePreview);
registerPlugin(FilePondPluginValidateSize);
// registerPlugin(FilePondPluginImageEdit);

// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';
// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

import { UpperCaseDirective } from '@app/directives/upper-case/upper-case.directive';
import { InputFormComponent } from '@app/components';

import { DevelopmentPreviewComponent } from './development-preview/development-preview.component';
import { CustomModalComponent } from './custom-modal/custom-modal.component';
import { ReturnHeaderComponent } from './return-header/return-header.component';
import { ModalBankaccountEditComponent } from './modal/modal-bankaccount-edit/modal-bankaccount-edit.component';
import { ModalStpComponent } from './modal/modal-stp/modal-stp.component';
import { ModalAddBankaccountComponent } from './modal/modal-add-bankaccount/modal-add-bankaccount.component';
import { ModalExampleIdComponent } from './modal/modal-example-id/modal-example-id.component';
import { ModalAddBeneficiaryComponent } from './modal/modal-add-beneficiary/modal-add-beneficiary.component';
import { ModalKnowledgeRisks } from './modal/modal-knowledge-risks/modal-knowledge-risks.component';
import { ModalPartsOnSaleComponent } from './modal/modal-parts-on-sale/modal-parts-on-sale.component';
import { ModalNipComponent } from './modal/modal-nip/modal-nip.component';
import { ModalSetNipComponent } from './modal/modal-set-nip/modal-set-nip.component';
import { InputFileComponent } from './input-file/input-file.component';
import { ModalOtpComponent } from './modal/modal-otp/modal-otp.component';
import { ModalVideoComponent } from './modal/modal-video/modal-video.component';
import { UserWithdrawComponent } from './user-withdraw/user-withdraw.component';
import { ModalCustomComponent } from './modal-custom/modal-custom.component';
import { ModalViewProjectsComponent } from './modal/modal-view-projects/modal-view-projects.component';
import { ModalViewResourcesComponent } from './modal/modal-view-resources/modal-view-resources.component';
import { ModalMfaComponent } from './modal/modal-mfa/modal-mfa.component';
import { ModalStpInstructionsComponent } from './modal/modal-stp-instructions/modal-stp-instructions.component';
import { ModalNotBalanceComponent } from './modal-not-balance/modal-not-balance.component';
import { ModalPromotionsComponent } from './modal/modal-promotions/modal-promotions.component';
import { InfoComponent } from './modal/modal-view-projects/info/info.component';
import { ModalFiscalUpdateComponent } from './modal/modal-fiscal-update/modal-fiscal-update.component';
import { ModalStpPendingComponent } from './modal/modal-stp-pending/modal-stp-pending.component';
import { ModalVerifyPwComponent } from './modal/modal-verify-pw/modal-verify-pw.component';
import { ModalPurchasePartMktComponent } from './modal-purchase-part-mkt/modal-purchase-part-mkt.component';
import { UserDirectDebitComponent } from './user-direct-debit/user-direct-debit.component';
import { ModalContractDomiciliationComponent } from './modal/modal-contract-domiciliation/modal-contract-domiciliation.component';
import { ModalModifyAutoinvestComponent } from './modal/modal-modify-autoinvest/modal-modify-autoinvest.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ModalChangeEmailComponent } from './modal/modal-change-email/modal-change-email.component';
import { ModalChangePhoneComponent } from './modal/modal-change-phone/modal-change-phone.component';
import { ModalPayPerformanceComponent } from './modal/development/modal-pay-performance/modal-pay-performance.component';
import { ModalAcceptResourcesComponent } from './modal/development/modal-accept-resources/modal-accept-resources.component';
import { ModalConfirmResourcesComponent } from './modal/development/modal-accept-resources/modal-confirm-resources/modal-confirm-resources.component';
import { ModalConfirmAutoinvestComponent } from './modal/modal-confirm-autoinvest/modal-confirm-autoinvest.component';
import { GraphDomComponent } from './modal/user-direct-debit/graph-dom/graph-dom.component';
import { ProfileLegalComponent } from './profile-legal/profile-legal/profile-legal.component';

import { Chart, registerables } from 'chart.js';
import { ModalConfirmDomiciliationComponent } from './modal/modal-confirm-domiciliation/modal-confirm-domiciliation.component';
import { ModalUploadIneComponent } from './modal/modal-upload-ine/modal-upload-ine.component';
import { ModalChangeEmailV2Component } from './modal/modal-change-email-v2/modal-change-email-v2.component';
Chart.register(...registerables);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    InputFormComponent,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    LazyLoadImageModule,
    MatTooltipModule,
    NgxMaskModule,
    FontAwesomeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SwiperModule,
    FilePondModule,
    CurrencyModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatRadioModule,
  ],
  declarations: [
    DevelopmentPreviewComponent,
    CustomModalComponent,
    ReturnHeaderComponent,
    ModalBankaccountEditComponent,
    ModalStpComponent,
    ModalAddBankaccountComponent,
    ModalExampleIdComponent,
    ModalAddBeneficiaryComponent,
    ModalKnowledgeRisks,
    ModalPartsOnSaleComponent,
    ModalNipComponent,
    ModalSetNipComponent,
    InputFileComponent,
    UpperCaseDirective,
    ModalOtpComponent,
    ModalVideoComponent,
    UserWithdrawComponent,
    UserDirectDebitComponent,
    ModalCustomComponent,
    ModalViewProjectsComponent,
    ModalViewResourcesComponent,
    ModalMfaComponent,
    ModalStpInstructionsComponent,
    ModalNotBalanceComponent,
    ModalPromotionsComponent,
    InfoComponent,
    ModalFiscalUpdateComponent,
    ModalStpPendingComponent,
    ModalVerifyPwComponent,
    ModalPurchasePartMktComponent,
    ModalContractDomiciliationComponent,
    ModalModifyAutoinvestComponent,
    ModalChangeEmailComponent,
    ModalChangeEmailV2Component,
    ModalChangePhoneComponent,
    ModalPayPerformanceComponent,
    ModalAcceptResourcesComponent,
    ModalConfirmResourcesComponent,
    ModalConfirmAutoinvestComponent,
    GraphDomComponent,
    ModalConfirmDomiciliationComponent,
    ModalUploadIneComponent,
    ProfileLegalComponent
  ],
  exports: [
    DevelopmentPreviewComponent,
    ReturnHeaderComponent,
    InputFileComponent,
    UpperCaseDirective,
    ModalStpComponent,
    ProfileLegalComponent
  ],
  providers: [
   CurrencyPipe,
  ]
})
export class SharedModule { }
